import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  ProfanityTerm,
  CreateProfanityTermRequest,
  UpdateProfanityTermRequest,
  UpdateProfanityTermsStatusRequest,
} from '../models/profanity-term.model';

@Injectable({
  providedIn: 'root',
})
export class ProfanityTermService {
  private readonly apiURL = '/api/profanity-terms';

  constructor(private http: HttpClient) {}

  getTerms(): Observable<ProfanityTerm[]> {
    return this.http.get<ProfanityTerm[]>(this.apiURL);
  }

  createTerm(request: CreateProfanityTermRequest): Observable<ProfanityTerm> {
    return this.http.post<ProfanityTerm>(this.apiURL, request);
  }

  updateTerm(id: number, request: UpdateProfanityTermRequest): Observable<ProfanityTerm> {
    return this.http.patch<ProfanityTerm>(`${this.apiURL}/${id}`, request);
  }

  updateStatus(id: number, isActive: boolean): Observable<ProfanityTerm> {
    const request: UpdateProfanityTermsStatusRequest = {
      is_active: isActive,
    };

    return this.http.patch<ProfanityTerm>(`${this.apiURL}/${id}/status`, request);
  }

  deleteTerm(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiURL}/${id}`);
  }
}
